<script setup>
import {computed, provide} from "vue";

const props = defineProps({
    wizard: {
        type: Object,
        required: true,
    },
    maxWidth: {
        type: [Number, String],
    }
});

provide('wizard', props.wizard);

const contentStyles = computed(() =>{
    const result = {};
    if (props.maxWidth) {
        result.maxWidth = typeof props.maxWidth === 'number' ? props.maxWidth + 'px' : props.maxWidth;
        result.margin = '0 auto';
    }

    return result
});
</script>

<template>
    <section class="wizard">
        <header v-if="$slots.header" class="wizard__header" :style="contentStyles">
            <slot name="header" :currentStep="wizard.currentStep.value"></slot>
        </header>
        <main class="wizard__content" :style="contentStyles">
            <slot></slot>
        </main>
    </section>
</template>
